<template>
    <!-- 数据列表  -->
    <div class="dataList" >
        <div v-for="(item,i) in dataList.list" :key="i"  class="flex align-center text-33 justify-start">
            <img class="pic" v-if="dataList.isSkill" :src="item.logo?item.logo:$nodata">
            <img class="pic" v-if="dataList.isContact" :src="item.head_img?item.head_img:$nodata">
            <div class="listInfo flex-one flex justify-between align-center">
                <div class="btnFl">
                    <div class="text-33">
                        <b class="text-24">{{dataList.isSkill?item.enterprise_title:item.user_name}}</b>{{dataList.isSkill?'':item.position_name}}
                    </div>
                    <span class="text-16">{{dataList.isSkill?item.address:item.user_phone}}</span>
                </div>
                <div class="btnRi  text-99  poi" @click="childChoicse(dataList.isSkill?item.e_id:item.u_id)">
                    选择
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    props:['dataList'],
    methods: {
        childChoicse(id){
            this.$emit('chidChoicseFun', id);
        },
    },
};
</script>
<style scoped>

.btnRi {
    color:#FF6633;
}
.apply {
  height: 30px;
  line-height: 30px;
  width: 41px;
  background: #ff7b00;
}
.dataList .pic{
    width:98px;
    height:98px;
    border-radius:5px;
    margin-right:25px;
    object-fit: contain;
}
.dataList>div {
    padding:28px 0;
    border-bottom:1px solid #eee;
}
.listTitle{
    font-size:24px;
}
.listDesc{
    font-size:16px;
    line-height:22px;
    margin:25px 0 20px;
}
.listInfo p{
    font-size:16px;
    padding-left:28px;
    line-height:18px;
    background-size: 17px 100%;
    background-position:center center;
}
.btnFl div{
    font-size:18px;
    margin-bottom:15px;
}
.btnFl div b{
    padding-right:13px;
}
.btnFl span{
    font-size:16px;
}
.listInfo p.edit{
    margin-right:35px;
}
.listInfo p.collect{
    background: url("../../../public/img/collect.png") no-repeat;
}
.listInfo p.zan{
    background: url("../../../public/img/zan.png") no-repeat;
}
.listInfo p.xiaoxi{
    background: url("../../../public/img/xiaoxi.png") no-repeat;
}

.listBtn  i{
    display:block;
    width:1px;
    height:18px;
    background:#999;
    margin:0 20px;
}
</style>